export enum TimelineEventVisibility {
    PUBLIC,
    ADMIN,
    USER,
}

export enum TimelineEventVariants {
    NONE = 'none',
    INFO = 'info',
    SHADE = 'shade',
    SUCCESS = 'success',
    WARNING = 'warning',
    ERROR = 'error',
    DECO_ONE = 'deco-one',
    DECO_TWO = 'deco-two',
}

export interface TimelineEventAttachment {
    name?: string | null
    id: string
}

export enum TimelineItemCategoryGroupType {
    General = 0,
    Financial = 1,
    Collection = 2,
    Statement = 3,
}

export enum TimelineItemCategoryType {
    General = 0,
    Order = 1,
    Invoice = 2,
    ServicePoint = 3,
    Contract = 4,
    Address = 5,
    User = 6,
    InvoiceProposal = 7,
    Statement = 8,
}

export enum TimelineContexts {
    COMPANY = 0,
    ORDER = 1,
    TRANSPORT = 2,
    STATEMENT = 3,
    INVOICE = 4,
    SERVICE_POINT = 5,
    INVOICE_PROPOSAL = 6,
    REIMBURSEMENT = 7,
}
